// @flow
import CONST from 'app/common/lib/Const';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';

const ApiErrorCodeToDesc: Map<number, string> = new Map([
  [1, 'INVALID_PARAMETERS'],
  [100, 'INVALID_NETWORK_ACCESS_TOKEN'],
  [105, 'FACEBOOK_ACCOUNT_NOT_LINKED'],
  [12, 'API_SERVER_ERROR'],
  [1202, 'LOGIN_MFA_TOKEN_INVALID'],
  [1203, 'MFA_CONNECTION_ERROR'],
  [13, 'API_DOWN'],
  [181, 'GPLUS_CONNECTION_ERROR'],
  [14, 'API_SERVER_SPAM_CONTENT'],
  [16, 'API_REQUEST_TIMEOUT'],
  [50, 'API_ERROR_PIN_NOT_FOUND'],
  [77, 'INVALID_PASSWORD_FB_USER'],
  [78, 'INVALID_PASSWORD_ERROR_CODE'],
  [79, 'INVALID_EMAIL_ERROR_CODE'],
  [80, 'INVALID_EMAIL_OR_PASSWORD'],
  [82, 'LOGIN_DEACTIVATED_USER'],
  [83, 'LOGIN_POLICY_VIOLATION_USER'],
  [85, 'AUTO_PASSWORD_RESET_ERROR_CODE'],
  [86, 'LOGIN_PANICKED_USER'],
  [87, 'LOGIN_SOFT_BANNED_USER'],
  [93, 'API_ERROR_UNDERAGE_REGISTER_ATTEMPT'],
  [99, 'LOGIN_PASSWORD_NOT_CREATED'],
  [8, 'API_LIMIT_EXCEEDED_ERROR'],
  [9, 'API_EVENT_BLOCKED_ERROR'],
  [19, 'USER_IN_SAFE_MODE'],
  [84, 'LOGIN_VOLUNTARILY_DEACTIVATED_USER'],
  [85, 'LOGIN_BAD_PASSWORD_ASK_RESET'],
  [1201, 'LOGIN_MFA_REQUIRED'],
  [30, 'LOGIN_USER_NOT_FOUND'],
  [88, 'LOGIN_HARD_BANNED_USER'],
  [429, 'RESPONSE_CODE_TOO_MANY_REQUESTS'],
]);

export default function trackLoginInFailure(
  error: Object,
  loggingData: Object,
  source: string = 'unknown_source',
  isCrossDomain: boolean = false,
) {
  if (error) {
    const api_error_code =
      error.http_status === CONST.RESPONSE_CODE_TOO_MANY_REQUESTS
        ? CONST.RESPONSE_CODE_TOO_MANY_REQUESTS
        : error.api_error_code;

    let error_des = api_error_code;
    if (ApiErrorCodeToDesc.has(api_error_code)) {
      error_des = ApiErrorCodeToDesc.get(api_error_code);
    }
    const { container } = loggingData;
    if (isCrossDomain) {
      trackRegisterAction(
        `unauth_web_client_cctld_login_api_error.${String(error_des)}.${container ||
          'unknow_container'}.${source}`,
      );
    } else {
      trackRegisterAction(
        `unauth_web_client_login_api_error.${String(error_des)}.${container ||
          'unknow_container'}.${source}`,
      );
    }
  }
}
